// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   ReviewsPage.responsive.css
   Responsive Stylesheet for Clinical Review Queue & Validation
   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED
   ========================================================================== */

/* ==========================================================================
   IPAD & TABLETS (max-width: 1024px)
   ========================================================================== */
@media (max-width: 1024px) {
  .mgreviews-page {
    width: 100%;
    max-width: 100vw;
    padding: 14px 18px 40px !important;
    overflow-x: hidden;
  }

  .mgreviews-hero {
    grid-template-columns: 1fr !important;
    gap: 22px !important;
    padding: 24px !important;
  }

  .mgreviews-hero h1 {
    font-size: clamp(28px, 4.2vw, 36px) !important;
    line-height: 1.1 !important;
  }

  .mgreviews-stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 12px !important;
    margin: 18px 0 !important;
  }

  .mgreviews-queue-grid {
    grid-template-columns: 1fr !important;
    gap: 16px !important;
  }
}

/* ==========================================================================
   MOBILE PHONES (max-width: 768px)
   ========================================================================== */
@media (max-width: 768px) {
  .mgreviews-page {
    padding: 10px 10px 30px !important;
  }

  .mgreviews-hero {
    padding: 16px 14px !important;
    gap: 16px !important;
    border-radius: 16px !important;
  }

  .mgreviews-hero h1 {
    font-size: 24px !important;
    line-height: 1.15 !important;
  }

  .mgreviews-hero p {
    font-size: 13px !important;
    line-height: 1.5 !important;
    margin: 10px 0 14px !important;
  }

  .mgreviews-actions {
    display: flex !important;
    gap: 8px !important;
    flex-wrap: wrap !important;
    width: 100% !important;
  }

  .mgreviews-actions .mgreviews-btn {
    flex: 1 1 auto !important;
    min-height: 40px !important;
    font-size: 12.5px !important;
  }

  /* Stats grid */
  .mgreviews-stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 6px !important;
    margin: 14px 0 !important;
  }

  .mgreviews-stat-card {
    padding: 10px 8px !important;
    border-radius: 12px !important;
  }

  .mgreviews-stat-card strong {
    font-size: 18px !important;
  }

  .mgreviews-stat-card span {
    font-size: 10px !important;
  }

  .mgreviews-stat-card small {
    display: none !important;
  }

  /* Queue list */
  .mgreviews-queue-grid,
  .reviews-grid {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
  }

  .mgreview-card,
  .review-card {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  .mgreview-card-top {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }

  .mgreview-badge-row {
    flex-wrap: wrap !important;
    gap: 6px !important;
  }

  .doctor-review-form {
    padding: 16px 14px !important;
    border-radius: 14px !important;
  }

  .doctor-review-form textarea,
  .doctor-review-form input,
  .doctor-review-form select {
    width: 100% !important;
    font-size: 13.5px !important;
  }

  .doctor-review-form .form-actions {
    flex-direction: column !important;
    gap: 8px !important;
  }

  .doctor-review-form .form-actions .btn {
    width: 100% !important;
    min-height: 42px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ReviewsPage.responsive.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;+EAE+E;AAC/E;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,8CAA8C;IAC9C,2BAA2B;EAC7B;;EAEA;IACE,2DAA2D;IAC3D,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;EACtB;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA,eAAe;EACf;IACE,2DAA2D;IAC3D,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,eAAe;EACf;;IAEE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;;;IAGE,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;AACF","sourcesContent":["/* ==========================================================================\n   ReviewsPage.responsive.css\n   Responsive Stylesheet for Clinical Review Queue & Validation\n   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED\n   ========================================================================== */\n\n/* ==========================================================================\n   IPAD & TABLETS (max-width: 1024px)\n   ========================================================================== */\n@media (max-width: 1024px) {\n  .mgreviews-page {\n    width: 100%;\n    max-width: 100vw;\n    padding: 14px 18px 40px !important;\n    overflow-x: hidden;\n  }\n\n  .mgreviews-hero {\n    grid-template-columns: 1fr !important;\n    gap: 22px !important;\n    padding: 24px !important;\n  }\n\n  .mgreviews-hero h1 {\n    font-size: clamp(28px, 4.2vw, 36px) !important;\n    line-height: 1.1 !important;\n  }\n\n  .mgreviews-stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 12px !important;\n    margin: 18px 0 !important;\n  }\n\n  .mgreviews-queue-grid {\n    grid-template-columns: 1fr !important;\n    gap: 16px !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONES (max-width: 768px)\n   ========================================================================== */\n@media (max-width: 768px) {\n  .mgreviews-page {\n    padding: 10px 10px 30px !important;\n  }\n\n  .mgreviews-hero {\n    padding: 16px 14px !important;\n    gap: 16px !important;\n    border-radius: 16px !important;\n  }\n\n  .mgreviews-hero h1 {\n    font-size: 24px !important;\n    line-height: 1.15 !important;\n  }\n\n  .mgreviews-hero p {\n    font-size: 13px !important;\n    line-height: 1.5 !important;\n    margin: 10px 0 14px !important;\n  }\n\n  .mgreviews-actions {\n    display: flex !important;\n    gap: 8px !important;\n    flex-wrap: wrap !important;\n    width: 100% !important;\n  }\n\n  .mgreviews-actions .mgreviews-btn {\n    flex: 1 1 auto !important;\n    min-height: 40px !important;\n    font-size: 12.5px !important;\n  }\n\n  /* Stats grid */\n  .mgreviews-stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 6px !important;\n    margin: 14px 0 !important;\n  }\n\n  .mgreviews-stat-card {\n    padding: 10px 8px !important;\n    border-radius: 12px !important;\n  }\n\n  .mgreviews-stat-card strong {\n    font-size: 18px !important;\n  }\n\n  .mgreviews-stat-card span {\n    font-size: 10px !important;\n  }\n\n  .mgreviews-stat-card small {\n    display: none !important;\n  }\n\n  /* Queue list */\n  .mgreviews-queue-grid,\n  .reviews-grid {\n    grid-template-columns: 1fr !important;\n    gap: 12px !important;\n  }\n\n  .mgreview-card,\n  .review-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .mgreview-card-top {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 8px !important;\n  }\n\n  .mgreview-badge-row {\n    flex-wrap: wrap !important;\n    gap: 6px !important;\n  }\n\n  .doctor-review-form {\n    padding: 16px 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .doctor-review-form textarea,\n  .doctor-review-form input,\n  .doctor-review-form select {\n    width: 100% !important;\n    font-size: 13.5px !important;\n  }\n\n  .doctor-review-form .form-actions {\n    flex-direction: column !important;\n    gap: 8px !important;\n  }\n\n  .doctor-review-form .form-actions .btn {\n    width: 100% !important;\n    min-height: 42px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
